import React from "react";
import { Route, Switch, Redirect } from "react-router";
// import { OrgsTeam } from "./orgsTeam";
import { Team } from "./team";
import EditCreate from "./editCreateTeam";
import { useSelector } from "react-redux";
import NoData from '../../apps/NoData'
import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg'

const Teams: React.FC = ({ match }: any) => {
    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const isViewable: boolean = orgPermissions.includes('team.View')

    return (
        <React.Fragment>
            {
                isViewable ?
                <Switch>
                    <Route exact path={match.path} component={Team} />
                    <Route exact path={match.path + "/create"} component={EditCreate} />
                    <Route exact path={match.path + "/:teamId/edit"} component={EditCreate} />
                    <Route exact path={match.path + "/:teamId"} component={Team} />
                    <Route component={() => <Redirect to='/404'/>}/>
                </Switch>
                :
                <NoData 
                  svg={WarningIcon}
                  header='Not Authorized'
                  content='Please request owner of this organization to provide access' 
                  noButton={true}
                />
            }
        </React.Fragment>
    );
};

export default Teams;
